// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminDamagesSurfaceUnits
} from '@/services/API/admin'

import {
  apiGetAdminRepMatParameters,
  apiPatchAdminRepMatParameters,
  apiDeleteAdminRepMatParameters,
  apiGetAdminRepTypes
} from '@/services/API/adminGag'

export default {
  name: 'repMat',
  data: function () {
    return {
      repMat: {
        rep_type: null,
        rep_type_code: null,
        rep_description: null,
        rep_mat: null,
        mat_format_sale: null,
        dam_measure_unit: null,
        conv_unit_per_mat_measure: null,
        mat_unit_price: null,
        is_hours: null,
        image: null
      },
      adminDamagesSurfaceUnits: [],
      adminRepTypes: []
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputSelect,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminRepMatParameters(this.currentPage)
        .then(repMat => {
          this.table = repMat.results
          this.totalPages = repMat.total_pages || 0
        })
    },
    handleEdit: function (data) {
      this.repMat = data
      this.$refs.adminGagEditModal.showModal = true
    },
    handleDelete: function (data) {
      apiDeleteAdminRepMatParameters(data).then(() => {
        this.handleSearch()
        this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
      })
    },
    handleSave: function () {
      apiPatchAdminRepMatParameters(this.repMat)
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminGagEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    },
    resetEditValues: function () {
      if (this.repMat) {
        Object.keys(this.repMat).forEach(parameter => { parameter = null })
      }
    },
    getAdminDamagesSurfaceUnits: function () {
      apiGetAdminDamagesSurfaceUnits()
        .then((data) => {
          this.adminDamagesSurfaceUnits = data
        })
    },
    getAdminRepTypes: function () {
      apiGetAdminRepTypes()
        .then((data) => {
          this.adminRepTypes = data
        })
    }
  },
  mounted: function () {
    this.getAdminRepTypes()
    this.getAdminDamagesSurfaceUnits()
  }
}
